module.exports = __webpack_public_path__ + "img/1F1F3-1F1F7.8f3a335c.svg";